import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// _mock
import { _addressBooks, INVOICE_SERVICE_OPTIONS } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import FormProvider, { RHFSelect } from 'src/components/hook-form';
//
import { DatePicker } from '@mui/x-date-pickers';
import { Box, Button, DialogActions, Divider, MenuItem } from '@mui/material';
import { useData } from 'src/contexts/gantt-chart/gantt-context';
import { dateformation2 } from 'src/components/date-format-mdy';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';
import { useSnackbar } from 'notistack';
import CreateEditSubcontractor from './create-edit-subcontractor';
import { LoadingScreen } from 'src/components/loading-screen';
// ----------------------------------------------------------------------

export default function Subcontractor({gantt, selectedDate,close }) {
  const router = useRouter();
  const [warning, setWarning] = useState('');
  const [selectedActivity,setSelectedActivity]=useState(null)
  const loadingSave = useBoolean();
    const { enqueueSnackbar } = useSnackbar();
 const [loading,setLoading]=useState(false)
  const loadingSend = useBoolean();
  const {dateWiseSubcontractor,refreshAssignData,getDateWiseSubcontractor,dateWiseSubcontractorLoading } = useData();
 useEffect(() => {
  getDateWiseSubcontractor(dateformation2(selectedDate));
  }, [selectedDate]);
  const NewInvoiceSchema = Yup.object().shape({});

  const defaultValues = useMemo(
    () => ({
      start_date: selectedDate,
      activity:'',
      items: [
        // {
        //   title: '',
        //   noOfPeople: '',
        //   noOfShifts: '',
        //   noOfDays: '',
        //   requiredHours: '',
        //   totalHours: '',
        //   skillLevel: '',
        //   rate: '',
        //   amount: 0,
        //   name: [],
        // },
      ],
    }),
    []
  );

  const methods = useForm({
    resolver: yupResolver(NewInvoiceSchema),
    defaultValues,
  });

  const {
    reset,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleSaveAsDraft = handleSubmit(async (data) => {});

  const handleCreateAndSend = handleSubmit(async (data) => {
    setLoading(true)
    const assigned_subcontractor=[]
    data.items.map((item)=>{
      assigned_subcontractor.push({
        user_id:item.nameOfSubcontractor,
        scope_of_work:item.scopeOfWork,
        trade_id:item.trade,
        quantity:item.quantity,
        availableQuantity:item.availableQuantity,
        unit_price:item.unitPrice,
        amount:item.amount,
      })
    })
    const dataForApi={
      assignable_id:data.activity,
      assignable_type:"App\\PlannedCostCode",
      assigned_subcontractor
    }

       try {
            const response = await postRequest(`${endpoints.ganttChart.assign_subcontractor}?date=${dateformation2(selectedDate)}`, dataForApi, false);
             console.log(response)
             if (response.metadata && response.metadata.success) {
              const refreshData= await refreshAssignData();
              gantt.parse(refreshData);
              close()
              await getDateWiseSubcontractor(dateformation2(selectedDate))
              reset()
              enqueueSnackbar({
                variant: 'success',
                message: 'Subcontractor has been assigned successfully.',
            });
              return
             }
            if (!(response.metadata && response.metadata.success)) {
              throw new Error(response?.message || 'Failed to assign');
            }
          } catch (err) {
            console.error('Error:', err);
            // setResourseData(JSON.parse(JSON.stringify(backupData))); // Restore deep copy
            handleErrorMessages(err.message || 'Submission failed.');
            return err.message;
          } finally{
           setLoading(false)
          }
  });

  return dateWiseSubcontractorLoading ? (
       <Box height={300} mb={5}>
          <LoadingScreen />
        </Box>
      ) : (
    <FormProvider methods={methods}>
      <Box
        gap={3}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(3, 1fr)',
          lg: 'repeat(3, 1fr)',
        }}
      >
        <Controller
          name="start_date"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <DatePicker
              disabled
              label="Start Date"
              value={field.value}
              onChange={(newValue) => {
                field.onChange(newValue);
                const endDate = methods.getValues('end_date');
                if (newValue && endDate && newValue > endDate) {
                  setError('start_date', {
                    message: 'Start Date cannot be later than End Date',
                  });
                } else {
                  clearErrors('start_date');
                  clearErrors('end_date');
                }
              }}
              slotProps={{
                textField: {
                 size:"small",
                  fullWidth: true,
                  error: !!error || !!warning,
                  helperText: error?.message || warning,
                },
              }}
            />
          )}
        />
        <RHFSelect onChange={(e)=>{
          setValue('activity',e.target.value)
          const selectedActivity=dateWiseSubcontractor?.activities?.find((item)=>item.id==e.target.value)
          setSelectedActivity(selectedActivity)
          if(selectedActivity.assigned_subcontractor && selectedActivity.assigned_subcontractor.length>0){
            let arr=[]
            selectedActivity.assigned_subcontractor.map((subItem)=>{
              arr.push({
                nameOfSubcontractor: subItem?.user_id,
                scopeOfWork:subItem?.scope_of_work,
                trade: subItem?.trade_id,
                quantity: subItem?.quantity,
                availableQuantity:0,
                unitPrice: subItem.unit_price,
                amount: subItem.amount,
              })
            })

            setValue('items',arr)
          }else{
            setValue('items',[
              {
                nameOfSubcontractor: '',
                scopeOfWork: '',
                trade: '',
                quantity: '',
                availableQuantity: '',
                unitPrice: '',
                amount: '',
              },
            ])

          }
        }} size="small" name="activity" label="Activity">
          {dateWiseSubcontractor?.activities?.map((service) => (
            <MenuItem key={service.id} value={service.id}>
              {service.description}
            </MenuItem>
          ))}
        </RHFSelect>
      </Box>
      <Divider sx={{marginTop:"20px"}}/>
      <CreateEditSubcontractor selectedActivity={selectedActivity}/>
      <DialogActions sx={{paddingRight:"0px"}}>
        <Button
          variant="outlined"
          onClick={() => {
             close();
          }}
          className="danager"
        >
          Cancel
        </Button>
        <LoadingButton loading={loading} variant="contained" onClick={handleCreateAndSend}>
          Submit
        </LoadingButton>
      </DialogActions>
    </FormProvider>
  );
}

Subcontractor.propTypes = {
  currentInvoice: PropTypes.object,
};
